import { Link } from "react-router-dom";
import { MessageSquare, Check, X, CheckCircle } from "lucide-react";
import UserChip from "../common/UserChip";

export default function ResponseCard({ response, postAuthorId, currentUserId, postId, onAccept, onReject, onComplete }) {
  const isAuthor = currentUserId === postAuthorId;

  return (
    <div className="flex items-center justify-between p-3 bg-linen rounded-lg">
      <div>
        <UserChip user={response.responder} />
        <p className="text-xs text-walnut-light mt-1 capitalize">
          {response.status}
          {response.completed_at && " (completed)"}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {isAuthor && response.status === "pending" && (
          <>
            <button
              onClick={() => onAccept(response.id)}
              className="p-2 rounded-md bg-sage/15 text-sage-dark hover:bg-sage/25 transition-colors"
              title="Accept"
            >
              <Check size={16} />
            </button>
            <button
              onClick={() => onReject(response.id)}
              className="p-2 rounded-md bg-coral/10 text-coral hover:bg-coral/20 transition-colors"
              title="Reject"
            >
              <X size={16} />
            </button>
          </>
        )}
        {response.status === "accepted" && !response.completed_at && (
          <>
            <Link
              to={`/chat/${response.id}`}
              className="p-2 rounded-md bg-terracotta/10 text-terracotta hover:bg-terracotta/20 transition-colors"
              title="Chat"
            >
              <MessageSquare size={16} />
            </Link>
            {isAuthor && (
              <button
                onClick={() => onComplete(response.id)}
                className="p-2 rounded-md bg-sage/15 text-sage-dark hover:bg-sage/25 transition-colors"
                title="Mark Complete"
              >
                <CheckCircle size={16} />
              </button>
            )}
          </>
        )}
        {response.completed_at && (
          <Link
            to={`/rate/${response.id}`}
            className="px-3 py-1.5 rounded-md bg-terracotta text-white text-xs font-medium hover:bg-terracotta-dark transition-colors"
          >
            Leave Review
          </Link>
        )}
      </div>
    </div>
  );
}
